const debate = [
  {
    "role": "Challenger",
    "lines": [
      "Dhīḥ! The subject, in just the way [Mañjuśrī debated]. Is whatever is a color necessarily white?"
    ],
    "index": 0
  },
  {
    "role": "Defender",
    "lines": [
      "I accept [that whatever is a color is necessarily white]."
    ],
    "index": 1
  },
  {
    "role": "Challenger",
    "lines": [
      "It [absurdly] follows that the subject, the color of the Buddha Amitāyus†, is white because of being a color. You asserted the pervasion [that whatever is a color is necessarily white]."
    ],
    "index": 2
  },
  {
    "role": "Defender",
    "lines": [
      "The reason is not established [the color of Buddha Amitāyus is a color]."
    ],
    "index": 3
  },
  {
    "role": "Challenger",
    "lines": [
      "It follows that the subject, the color of the Buddha Amitāyus, is a color because of being sutiable as a hue.‡"
    ],
    "index": 4
  },
  {
    "role": "Defender",
    "lines": [
      "There is no pervasion [i.e., even though it is true that the color of the Buddha Amitāyus is suitable as a hue§, it is not the case that whatever is suitable as a hue is necessarily a color]."
    ],
    "index": 5
  },
  {
    "role": "Challenger",
    "lines": [
      "It follows that there is pervasion [i.e., whatever is suitable as a hue is necessarily a color] because suitable as a hue is the definition of color."
    ],
    "index": 6
  },
  {
    "role": "Defender",
    "lines": [
      "I accept that the color of Buddha Amitāyus is a color."
    ],
    "index": 7
  },
  {
    "role": "Challenger",
    "lines": [
      "It follows that the subject, the color of the Buddha Amitāyus, is white because of being a color.**"
    ],
    "index": 8
  },
  {
    "role": "Defender",
    "lines": [
      "I accept that the color of the Buddha Amitāyus is white."
    ],
    "index": 9
  },
  {
    "role": "Challenger",
    "lines": [
      "It follows that the subject, the color of Buddha Amitāyus, is not white because of being red.††"
    ],
    "index": 10
  },
  {
    "role": "Defender",
    "lines": [
      "The reason [that the color of the Buddha Amitāyus is red] is not established."
    ],
    "index": 11
  },
  {
    "role": "Challenger",
    "lines": [
      "It follows that the subject, the color of Buddha Amitāyus, is red because of being the isolate‡‡ of the color of the Buddha Amitāyus."
    ],
    "index": 12
  },
  {
    "role": "Defender",
    "lines": [
      "The reason [that the color of Buddha Amitāyus is the isolate of the color of the Buddha Amitāyus] is not established."
    ],
    "index": 13
  },
  {
    "role": "Challenger",
    "lines": [
      "It follows with respect§§ to the subject, the color of the Buddha Amitāyus, that it is its own isolate because it is an established base.***"
    ],
    "index": 14
  },
  {
    "role": "Defender",
    "lines": [
      "I accept that the subject, the color of the Buddha Amitāyus, is an isolate of the color of the Buddha Amitāyus."
    ],
    "index": 15
  },
  {
    "role": "Challenger",
    "lines": [
      "It follows that the subject, the color of Buddha Amitāyus, is red."
    ],
    "index": 16
  },
  {
    "role": "Defender",
    "lines": [
      "I accept it."
    ],
    "index": 17
  },
  {
    "role": "Challenger",
    "lines": [
      "It follows that the subject, the color of Buddha Amitāyus, is not white because of being red."
    ],
    "index": 18
  },
  {
    "role": "Defender",
    "lines": [
      "I accept it."
    ],
    "index": 19
  },
  {
    "role": "Challenger",
    "lines": [
      "It follows that the subject, the color of the Buddha Amitāyus, is white because of being a color.†††"
    ],
    "index": 20
  },
  {
    "role": "Defender",
    "lines": [
      "There is no pervasion. ‡‡‡"
    ],
    "index": 21
  },
  {
    "role": "Challenger",
    "lines": [
      "It follows that whatever is a color is not necessarily white."
    ],
    "index": 22
  },
  {
    "role": "Defender",
    "lines": [
      "I accept it."
    ],
    "index": 23
  },
  {
    "role": "Challenger",
    "lines": [
      "Tshar! Tshar! Tshar!§§§ [Finished! Finished! Finished!]",
      "[Your] basic thesis is finished!"
    ],
    "index": 24
  }
];

const notes = [
  {
    "symbol": [
      "*"
    ],
    "note": "* Debate A.2, Second Mistaken View, Dan Perdue, Debate in Tibetan Buddhism, pp. 223"
  },
  {
    "symbol": [
      "†"
    ],
    "note": "† “infinite light”, an aspect of Buddha Amitābha, who is master of one of the five Buddha lineages, associated with the western direction and the color red. He ist lord of the pure land called “Land of Happiness”"
  },
  {
    "symbol": [
      "‡"
    ],
    "note": "‡ This could be restated as a syllogism and still be a valid argument."
  },
  {
    "symbol": [
      "§"
    ],
    "note": "§ By convetion, when the defender denies the pervasion, he or she has implicity accepted that the reason is established."
  },
  {
    "symbol": [
      "**"
    ],
    "note": "** Having gotten the defender to accept that the color of Buddha Amitayus is a color, the challenger again poses the basic (absurd) consequence, that the subject is white because of being a color. The defender asserted the original pervasion, that whatever is a color is necessarily white, and has come to accept the reason, that the color of Buddha Amitayus is a color; he will now accept the basic absurd consequence: that the color of Buddha Amitayaus is white."
  },
  {
    "symbol": [
      "††"
    ],
    "note": "†† Here the challenger is refuting the defender’s acceptance of the subject as white by saying that it is, in fact, red. This follows from the pervasion that primary colors are mutually exclusive: nothing is both white and red, and, more generally, there is no common locus between two primary colors."
  },
  {
    "symbol": [
      "‡‡"
    ],
    "note": "‡‡ “that which is reversed from what is not one with it”, or not-not-one with itself, or one with itself. Any existent is one with itself if it is exactly the same in both name and meaning. A phenomena is exactly the same as itself and different from all else, thus it is called an “isolate” because it is a phenomena in isolation from all else. Therefore, the color of Buddha Amitāyus, and only that, is one with the color of Buddha Amitāyus, and thereby it alone is also the isolate of the color of Buddha Amitāyus."
  },
  {
    "symbol": [
      "§§"
    ],
    "note": "§§ This consequence is stated generally using “with respect to” and “it” to avoid logical faults that would result from the more typical formulation (see Perdue pp. 228-229)"
  },
  {
    "symbol": [
      "***"
    ],
    "note": "*** Each and every stablished base, or existent, has the quality of being its own isolate. A pot is a pot’s isolate. However, this does not mean that a pot’s isolate is a pot; a pot’s isolate is a permanent phenomenan because it is a conceptual abstraction and cannot be a thing. Instead, a pot is (has the quality of being) a pot’s isolate because it is one with a pot—exatly the same as a pot in both name and meaning."
  },
  {
    "symbol": [
      "†††"
    ],
    "note": "††† 3rd restatement of basic consequence"
  },
  {
    "symbol": [
      "‡‡‡"
    ],
    "note": "‡‡‡ Here the defender is abandoning his original position that began the debate"
  },
  {
    "symbol": [
      "§§§"
    ],
    "note": "§§§ Most agree that the debater here shouts “Finished!”, meaning that defender’s original misconception has ended. Others hold that the challenger shouts “Amazing (mtshar)!”, i.e. that a person would say one thing and later contradict their own assertion is amazing. Each time he or she says it, they slap their right hand with palm upraised with their left palm."
  }
];

export default {
  debate,
  notes
};
